<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          navText="Métricas"
        >
          <template v-slot:icon>
            <i class="fas fa-home text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role==='1' || user?.role==='2'">
        <sidenav-item
          url="/pos"
          :class="getRoute() === 'pos' ? 'active' : ''"
          navText="POS"
        >
          <template v-slot:icon>
            <i class="fas fa-cash-register text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role==='1' || user?.role==='2'">
        <sidenav-item
          url="/users"
          :class="getRoute() === 'users' ? 'active' : ''"
          navText="Usuarios"
        >
          <template v-slot:icon>
            <i class="fas fa-users text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role==='3'">
        <sidenav-item
          url="/production-user"
          :class="getRoute() === 'production-user' ? 'active' : ''"
          navText="Producción"
        >
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

     <!--  <li class="nav-item" v-if="user?.role==='1' || user?.role==='2'">
        <sidenav-item
          url="/inventory"
          :class="getRoute() === 'inventory' ? 'active' : ''"
          navText="Inventario"
        >
          <template v-slot:icon>
            <i class="fas fa-tshirt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->


      <li class="nav-item" v-if="user?.role==='1' || user?.role==='2'">
        <sidenav-item
          url="/supplies"
          :class="getRoute() === 'supplies' ? 'active' : ''"
          navText="Inventario"
        >
          <template v-slot:icon>
            <i class="fas fa-box text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role==='1' || user?.role==='2'">
        <sidenav-item
          url="/purchases"
          :class="getRoute() === 'purchases' ? 'active' : ''"
          navText="Pedidos"
        >
          <template v-slot:icon>
            <i class="fas fa-shopping-cart text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

       <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/remissions" :class="getRoute() === 'remissions' ? 'active' : ''" navText="Ventas">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role==='1' || user?.role==='2'">
        <sidenav-item
          url="/worker-tasks"
          :class="getRoute() === 'worker-tasks' ? 'active' : ''"
          navText="Trabajos y Deudas"
        >
          <template v-slot:icon>
            <i class="fas fa-tools text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role==='1' || user?.role==='2'">
        <sidenav-item
          url="/cash-closures"
          :class="getRoute() === 'cash-closures' ? 'active' : ''"
          navText="Cierres de Caja"
        >
          <template v-slot:icon>
            <i class="fas fa-cash-register text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- <li class="nav-item" v-if="user?.role==='1' || user?.role==='2'">
        <sidenav-item
          url="/nomina"
          :class="getRoute() === 'nomina' ? 'active' : ''"
          navText="Nomina"
        >
          <template v-slot:icon>
            <i class="fas fa-money-bill text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <!-- <li class="nav-item" v-if="user?.role==='1' || user?.role==='2'">
        <sidenav-item
          url="/reports"
          :class="getRoute() === 'reports' ? 'active' : ''"
          navText="Informes"
        >
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->
     
     
    </ul>
  </div>
  <div class="mx-3 sidenav-footer text-center mt-3">
   

  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";


export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      dropDownStatus: true,
      user:{}
    };
  },
  components: {
    SidenavItem,
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      this.user = user;
    } 
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    useDropDown() {
      this.dropDownStatus = !this.dropDownStatus;
    },
   
  },
};
</script>
